import {
  styled,
  CircularProgress,
  Box,
  Typography,
  Button,
  Tab,
  FormLabel,
} from "@mui/material";
import { brighthiveTheme } from "../../../theme/theme";
import { Tabs } from "../../../common/Tabs/Tabs";

export const CircularProgressCustom = styled(CircularProgress)`
  display: block;
  margin: 40px auto;
`;
export const DialogBox = styled(Box)`
  padding: 20px;
  .head {
    display: flex;
    align-items: center;
    padding: 0 20px 10px;
    border-bottom: 1px solid
      ${brighthiveTheme.palette.action.disabledBackground};
    margin: 0 -20px 14px;
    h2 {
      font-size: 20px;
      line-height: 24px;
    }
  }
  .footer {
    display: flex;
    justify-content: end;
    padding: 20px 20px 0;
    border-top: 1px solid ${brighthiveTheme.palette.action.disabledBackground};
    margin: 0 -20px;
    button.red {
      color: ${brighthiveTheme.palette.error.main};
    }
  }
  .content {
    margin: 0 0 20px;
    min-height: 200px;
  }
`;
